import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า SGOT โดยใช้ค่าปกติจาก medium.json
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'SGOT (AST)', gender, age, 'SGOT');
};
